import Vue from 'vue'
import service from '../services/notificationExpenseService.js'

export function useNotificationExpense() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getClients(params = {}) {
    state.loading = true
    try {
      const response = await service.getClients(params)
      state.items = response.emails.current_page === 1
        ? [...response.emails.data]
        : [...state.items, ...response.emails.data]
      state.currentPage = response.emails.current_page
      state.lastPage = response.emails.last_page
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function updateEmails(params = {}) {
    state.loading = true
    try {
      const response = await service.updateEmails(params)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function changeStatus(params = {}) {
    state.loading = true
    try {
      const response = await service.changeStatus(params)
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getClients, updateEmails, changeStatus }
}
